export const originalFilenameToMimeType = (name: string | undefined) => name?.split(".").pop()?.toLowerCase() || "";
